// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-group-append .btn[data-v-a33ee622] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
